/**
 * Shared component for API documentation links.
 * Used in Footer and Login components to avoid code duplication.
 */

const linkStyle = {
  background: 'none',
  border: 'none',
  color: 'var(--myant-primary)',
  cursor: 'pointer',
  textDecoration: 'underline',
  fontSize: '0.875rem',
  padding: 0,
  margin: '0 0.25rem',
} as const;

export function ApiDocsLinks() {
  return (
    <>
      <span>|</span>
      <a
        href="/docs"
        target="_blank"
        rel="noopener noreferrer"
        style={linkStyle}
      >
        API Docs (Swagger)
      </a>
      <span>|</span>
      <a
        href="/redoc"
        target="_blank"
        rel="noopener noreferrer"
        style={linkStyle}
      >
        API Docs (ReDoc)
      </a>
      <span>|</span>
      <a
        href="/openapi.json"
        target="_blank"
        rel="noopener noreferrer"
        style={linkStyle}
      >
        OpenAPI JSON
      </a>
      <span>|</span>
      <a
        href="/openapi.yaml"
        target="_blank"
        rel="noopener noreferrer"
        style={linkStyle}
      >
        OpenAPI YAML
      </a>
    </>
  );
}
